import React, { useState, useEffect, Fragment } from "react";
import { RootState, useAppDispatch } from "../../../redux/store";

import { Autista } from "../anagrafiche/anagraficheSlice";
import { assegnaAutista } from "../schedeCarico/schedeCaricoSlice";

import { Box } from "@mui/system";
import DnDBox from "../../common/DnDBox";

import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LinearProgress from "@mui/material/LinearProgress";
import RvHookupIcon from "@mui/icons-material/RvHookup";
import Tooltip from "@mui/material/Tooltip";
import AirlineSeatReclineNormalIcon from "@mui/icons-material/AirlineSeatReclineNormal";

interface AutistaCardProps {
	autista: Autista;
	handlerAssegnaAutista: (
		dragId: number,
		hoverValue: {
			schedaCarico_id: number;
			lotto_id: number;
			data_lavorazione: Date | string;
		}
	) => void;
}

const AutistaCard = ({ autista, handlerAssegnaAutista }: AutistaCardProps) => {
	return (
		<DnDBox
			key={autista.id}
			id={autista.id || 9999}
			index={autista.id}
			typeBox={"AUTISTA"}
			accept={"day_"}
			moveDnDBox={() => {
				console.log("AUTISTA");
			}}
			dragDnDBox={handlerAssegnaAutista}
			// disabled={lotto.resa_confermata}
		>
			<Card
				key={autista.id}
				sx={{
					backgroundColor:
						autista.stato_autista_alla_data.stato == 0
							? "white"
							: autista.stato_autista_alla_data.stato == 1
							? "lightgreen"
							: autista.stato_autista_alla_data.stato == 2
							? "#51acf5"
							: autista.stato_autista_alla_data.stato == 3
							? "#ffdc10"
							: autista.stato_autista_alla_data.stato == 4
							? "#999"
							: "#ff8072",
					border: autista.stato_autista_alla_data.viaggio_lungo
						? "1"
						: "inherit",
					borderStyle: autista.stato_autista_alla_data.viaggio_lungo
						? "solid"
						: "inherit",
					borderColor: autista.stato_autista_alla_data.viaggio_lungo
						? "darkviolet"
						: "inherit",

					pb: 0,
				}}
			>
				<CardContent sx={{ p: 0.6, "&:last-child": { pb: 0 } }}>
					<Grid container spacing={0.5}>
						<Grid item xs={2}>
							<Box sx={{ flexGrow: 1 }} display="grid" justifyContent="center">
								<Tooltip
									title={
										autista.stato_autista_alla_data.descrizione +
										" " +
										autista.stato_autista_alla_data.messaggio
									}
									placement="left-start"
									disableFocusListener
									enterTouchDelay={10}
									arrow
								>
									<AirlineSeatReclineNormalIcon
										sx={{
											color: autista.stato_autista_alla_data.viaggio_lungo
												? "darkviolet"
												: autista.stato_autista_alla_data.stato == 0
												? "#555"
												: autista.stato_autista_alla_data.stato == 1
												? "green"
												: autista.stato_autista_alla_data.stato == 2
												? "#053df5"
												: autista.stato_autista_alla_data.stato == 3
												? "#ffa010"
												: autista.stato_autista_alla_data.stato == 4
												? "#222"
												: "red",
										}}
									/>
								</Tooltip>
							</Box>
						</Grid>
						<Grid item xs={5}>
							<Box sx={{ flexGrow: 2 }}>{autista.cognome}</Box>
						</Grid>
						<Grid item xs={5}>
							<Box sx={{ flexGrow: 2 }}>{autista.nome}</Box>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		</DnDBox>
	);
};

interface AutistiBoxProps {
	autisti: Autista[];
}
const AutistiBox = ({ autisti }: AutistiBoxProps) => {
	const style = {
		position: "absolute" as "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		maxWidth: 400,
		width: "95%",
		bgcolor: "background.paper",
		border: "2px solid #000",
		boxShadow: 24,
		p: 4,
		pb: 1,
		textAlign: "center",
	};
	const [tuttiAutistiOn, setTuttiAutistiOn] = useState<boolean>(false);
	const dispatch = useAppDispatch();

	const handlerAssegnaAutista = (
		dragId: number,
		hoverValue: {
			schedaCarico_id: number;
			lotto_id: number;
			data_lavorazione: Date | string;
		}
	) => {
		// dragId identifica l'autista
		// in hoverValue si identifica la scheda carico, id del lotto e data di lavorazione
		hoverValue &&
			dispatch(
				assegnaAutista({
					autista_id: dragId,
					schedaCarico_id: hoverValue.schedaCarico_id,
					lotto_id: hoverValue.lotto_id,
					data_lavorazione: hoverValue.data_lavorazione,
				})
			);
	};

	return (
		<Stack direction="column" spacing={1} justifyContent="center">
			{autisti
				.filter((autista) => autista.dipendente == true)
				.map((autista) => (
					<AutistaCard
						key={"autista_" + autista.id}
						autista={autista}
						handlerAssegnaAutista={handlerAssegnaAutista}
					/>
				))}

			{tuttiAutistiOn && (
				<Fragment>
					<Divider>Autisti non dipendenti</Divider>
					{autisti
						.filter((autista) => autista.dipendente == false)
						.map((autista) => (
							<AutistaCard
								key={"autista_" + autista.id}
								autista={autista}
								handlerAssegnaAutista={handlerAssegnaAutista}
							/>
						))}
				</Fragment>
			)}

			<Button
				onClick={() => setTuttiAutistiOn(!tuttiAutistiOn)}
				sx={{ color: "white" }}
			>
				{" "}
				{tuttiAutistiOn
					? "Mostra solo autisti dipendenti"
					: "Mostra tutti gli autisti"}
			</Button>
		</Stack>
	);
};

export default AutistiBox;
